module.exports = __webpack_public_path__ + "files/1d5c6f1814b0a203f251969949840c3b.png";